export function makeCompanyNav(slug) {
  return [
    //top
    { to: `/dashboard/${slug}`, label: "Översikt", icon: "", end: true },
    { to: `/tasks/${slug}`,     label: "Tasks & anteckningar", icon: "", end: true },
    { to: `/activity/${slug}`,  label: "Aktivitet", icon: "", end: true },
    slug ? { to: `/hitta-kopare/${slug}`, label: "Hitta köpare", icon: "", end: true } : null,
    { to: `/pipeline/${slug}`,  label: "Hantera köpare", icon: "", end: true },
    { to: `/valuation/${slug}`, label: "Värdering", icon: "", end: true },
    { to: `/finance/${slug}`,   label: "Finans", icon: "", end: true },
    { to: `/pm/${slug}`,        label: "PM Studio", icon: "", end: true },
    { to: `/duediligence/${slug}`,        label: "Due diligence", icon: "", end: true },
    { to: `/dataroom/${slug}`,        label: "Datarum", icon: "", end: true },
    { to: `/koncern/${slug}`,         label: "Koncern", icon: "", end: true },
    { to: `/logg/${slug}`,        label: "Logg", icon: "", end: true },
    { to: `/settings/`,        label: "Kontoinställningar", icon: "", end: true },
//bottom
    { to: `/prospect/`,        label: "Prospektering", icon: "", end: true },
    { to: `/settings/${slug}`,        label: "Deltagare och inställningar", icon: "", end: true },
    { to: `/projects/`,        label: "Projekt", icon: "", end: true },
    { to: `/check/`, label: "Start", icon: "", end: true},

  ].filter(Boolean);
}

/**
 * Nav items shown in the buyer portal. The buyer only sees the modules
 * the broker granted them (passed via `modules` from /users/buyer-portal/).
 * Q&A is always available since every buyer can reach the broker with
 * questions. Projects/Settings at the bottom come from the shared cluster.
 */
export function makeBuyerNav(slug, modules = []) {
  const has = (m) => Array.isArray(modules) && modules.includes(m);
  const items = [];
  if (has("dataroom"))  items.push({ to: `/buyer/${slug}/dataroom`,  label: "Datarum", end: true });
  items.push({ to: `/buyer/${slug}/qa`, label: "Q&A", end: true });
  if (has("valuation")) items.push({ to: `/buyer/${slug}/valuation`, label: "Värdering", end: true });
  if (has("im"))        items.push({ to: `/buyer/${slug}/im`,        label: "PM", end: true });
  if (has("dd"))        items.push({ to: `/buyer/${slug}/dd`,        label: "Due diligence", end: true });
  // Buyer admins can manage their own company's members in this workspace.
  items.push({ to: `/buyer/${slug}/team`, label: "Team", end: true });
  // Bottom cluster (shared)
  items.push({ to: `/projects/`, label: "Projekt", end: true });
  items.push({ to: `/settings/`, label: "Settings", end: true });
  return items;
}

/**
 * Nav items for the seller portal. Dataroom + Q&A are always available —
 * the seller needs to upload files and answer questions regardless of
 * per-invite module grants. Module-gated pages are the DD questionnaire,
 * financials upload, and company-details editor.
 */
export function makeSellerNav(slug, modules = []) {
  const has = (m) => Array.isArray(modules) && modules.includes(m);
  const items = [
    { to: `/seller/${slug}/dataroom`, label: "Datarum", end: true },
    { to: `/seller/${slug}/qa`,       label: "Q&A", end: true },
  ];
  if (has("financials"))      items.push({ to: `/seller/${slug}/financials`,      label: "Finansiell data", end: true });
  if (has("dd"))              items.push({ to: `/seller/${slug}/dd`,              label: "Due diligence", end: true });
  if (has("company_details")) items.push({ to: `/seller/${slug}/company`,         label: "Bolagsinfo", end: true });
  // Valuation + Informationsmemorandum are read-only for the seller and
  // shown unconditionally. The IM page itself returns {finalized:false}
  // until the broker clicks "Färdigställ PM", so sellers never see drafts.
  items.push({ to: `/seller/${slug}/valuation`, label: "Värdering", end: true });
  items.push({ to: `/seller/${slug}/im`, label: "Informationsmemorandum", end: true });
  items.push({ to: `/seller/${slug}/team`, label: "Team", end: true });
  items.push({ to: `/projects/`, label: "Projekt", end: true });
  items.push({ to: `/settings/`, label: "Settings", end: true });
  return items;
}
